// src/components/AppLayout.js
import React from "react";
import { Box } from "@mui/material";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import { Outlet } from "react-router-dom";

export default function AppLayout() {
  return (
    <Box sx={{ display: "flex" }}>
      {/* Sidebar on the left */}
      <Sidebar />

      {/* Main content area */}
      <Box sx={{ flexGrow: 1 }}>
        {/* Navbar at the top */}
        <Navbar />

        {/* Main page content below the navbar */}
        <Box
          component="main"
          sx={{
            mt: 8, // Navbar height offset (64px)
            ml: "-50px", // Sidebar width offset
            p: 2, // Padding for content
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
